export const DAILY_POOL = 'Daily Pool';
export const PRE_LAUNCH_POOL = 'Pre-launch Pool';
export const ALL_TERM = 'All';

export const TERM_LABEL = 'Term';
export const TERM_ITEMS_TYPES = [ALL_TERM, DAILY_POOL, PRE_LAUNCH_POOL];
